var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.codeViewer,attrs:{"data-testid":"codeViewer"}},[_c('pre',[_c('code',{staticClass:"language-json"},[_vm._v(_vm._s(_vm.code))])])])}
var staticRenderFns = []

export { render, staticRenderFns }